import { useEffect, useState } from "react";

const useIsOverflowing = (ref: React.RefObject<HTMLElement>) => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (ref.current) {
        setIsOverflowing(ref.current.scrollHeight > ref.current.clientHeight);
      }
    };

    checkOverflow();

    if (ref.current) {
      const observer = new ResizeObserver(checkOverflow);
      observer.observe(ref.current);

      return () => {
        observer.disconnect();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current]);

  return isOverflowing;
};

export { useIsOverflowing };
